import type { FaireProductEntity } from "../../entity_types/product";

export const p_dn9xyjnhz7: FaireProductEntity = {
  token: "p_dn9xyjnhz7",
  type: "product",
  name: "6oz Bulk Soy Candles, Clear Jar with Wooden Lids",
  brandToken: "b_pkmh9hr2u4",
  brandName: "Rwildlife",
  imageUrl:
    "https://cdn.faire.com/fastly/a451e899895320e46171c57caf0ca19b9cf4fccd4c73126993d374638689974e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/856fc6b2a3852198422265508be03bed0914907dc59be58bce4cb7fa168b138c.jpeg",
    "https://cdn.faire.com/fastly/e77ca6e90ad34582d5128871df9b21d7990ebeac68748e6772ef60a6ca977861.jpeg",
    "https://cdn.faire.com/fastly/797c6e8159e816d9d6502360ad24448102f819e8bfd38920b61a3e9533e7b3ed.jpeg",
    "https://cdn.faire.com/fastly/f3339dc8fc325bbd99b798e657ccbb68ef41ee79d46140de42b66ad9b9110fe6.jpeg",
    "https://cdn.faire.com/fastly/66ff2cc3eafa8a4e4f12312b02069ae8ede1c50b2d535c5c21f7a2c086b70ff2.jpeg",
    "https://cdn.faire.com/fastly/9f3f9236ee131105a66cf616fb04615a532fdf8e391d5e18316e896be99851b9.jpeg",
    "https://cdn.faire.com/fastly/cb25e360a52e8e32ca6f852d54e0ab7dc3ec918ea486cdee0b2a167fddb554b0.jpeg",
    "https://cdn.faire.com/fastly/49bc4f5c8cee23f5323962b03fb7a7fb6fa0db9f8b3948c7840e463cacd3fd0a.jpeg",
  ],
  priceDollars: 9.5,
  description:
    "Our Bulk Candle Package includes 12 candles and 12 lids. Perfect for bulk gifts or private label. (top/custom label is not included) \n\nScent options include\n1) Warm & Cozy Vanilla\n2)Eucalyptus & Sage\n3)Wildflower & Rose\n4) Lavender Spa.\n-Or unscented \n\n Each candle is hand poured into a beautiful small jar that can be reused. Our soy wax is all natural and vegan with highly fragrant, strong and long lasting scents, featuring lead free cotton wicks. All handmade in Delray Beach, FL. Each candle is single-wick, 6oz (jars are 2.8 inches in diameter and 3.5 inches tall). Bottom of the jars will have a warning sticker\n\nOur goal is to give back to our communities and donate partial proceeds to wildlife conservation and animal rescues. In addition, all orders are shipped using recycled packaging to help with sustainability and reduce waste.",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:56.604Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
